import LandingPage from "./pages/LandingPage";

export function App() {
    return <LandingPage />;
}

export default App;
